import { initDoc } from './../common/doc';
export function initProductRequest(request) {
    const init = Object.assign(Object.assign({}, initDoc()), { collection: 'product-requests', email: '', primaryContactName: '', companyName: '', phoneNumber: '', po: '', dateNeeded: new Date(), items: [], comments: '', agreement: false });
    return Object.assign(Object.assign({}, init), request);
}
export function initProductRequestItem(requestItem) {
    const init = {
        id: '',
        quantity: 1,
        name: '',
        size: ''
    };
    return Object.assign(Object.assign({}, init), requestItem);
}
